import { Fragment } from 'react';
import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';
import { useTestSeriesData } from './useTestSeriesData';

const F1Filter = styled.div`
  display: flex;
  padding: 14px 20px;
  gap: 8px;
  border-radius: 8px;
  border-width: 0.8px;
  background-color: var(--color-base-0);
  border: 1px solid var(--color-divider);

  ${mediaQuery.uptoMobile} {
    padding: 14px 16px;
  }
`;

const F1Divider = styled.div`
  width: 1px;
  height: 20px;
  background-color: var(--color-divider);
`;

const F1FilterSelection = styled.div`
  height: 2px;
  width: 100%;
  position: absolute;
  bottom: -15px;
  background-color: var(--color-primary-focus);
`;

const F1FilterItem = styled.div<{ selected?: boolean }>`
  font-weight: 600;
  font-size: 20px;
  position: relative;
  line-height: 19.2px;
  letter-spacing: -1.5%;
  cursor: pointer;
  color: ${({ selected }) =>
    selected ? 'var(--color-primary-focus)' : 'inherit'};

  ${mediaQuery.uptoMobile} {
    font-size: 16px;
  }
`;

const F2Filter = styled.div`
  display: flex;
  gap: 12px;

  ${mediaQuery.uptoMobile} {
    justify-content: space-evenly;
  }
`;

const F2FilterItem = styled.div<{ isSelected: boolean }>`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0%;

  background-color: ${({ isSelected }) =>
    isSelected ? 'var(--color-accent-blue)' : 'var(--color-base-0)'};
  color: ${({ isSelected }) =>
    isSelected ? 'var(--color-base-0)' : 'var(--color-text-primary)'};
  border: 1px solid var(--color-divider);
  gap: 8px;
  cursor: pointer;
  border-radius: 56px;
  padding: 6px 20px;

  ${mediaQuery.uptoMobile} {
    border: none;
  }
`;

const F1AndF2Filters = ({
  selectedF1: propSelectedF1,
  setSelectedF1: propSetSelectedF1,
  selectedF2: propSelectedF2,
  setSelectedF2: propSetSelectedF2,
  allPossibleF1: propAllPossibleF1,
  allPossibleF2: propAllPossibleF2
}: {
  selectedF1?: string;
  setSelectedF1?: (val: string) => void;
  selectedF2?: string;
  setSelectedF2?: (val: string) => void;
  allPossibleF1?: string[];
  allPossibleF2?: string[];
} = {}) => {
  // Fallback to context if props not provided
  const context = useTestSeriesData?.();
  const selectedF1 = propSelectedF1 ?? context?.selectedF1 ?? '';
  const setSelectedF1 =
    propSetSelectedF1 ?? context?.setSelectedF1 ?? (() => {});
  const selectedF2 = propSelectedF2 ?? context?.selectedF2 ?? '';
  const setSelectedF2 =
    propSetSelectedF2 ?? context?.setSelectedF2 ?? (() => {});
  const allPossibleF1 = propAllPossibleF1 ?? context?.allPossibleF1 ?? [];
  const allPossibleF2 = propAllPossibleF2 ?? context?.allPossibleF2 ?? [];

  return (
    <>
      <F1Filter>
        {allPossibleF1?.map((item, idx) => (
          <Fragment key={item}>
            {idx !== 0 && <F1Divider />}
            <F1FilterItem
              selected={selectedF1 === item}
              onClick={() => setSelectedF1(item)}
            >
              {selectedF1 === item && <F1FilterSelection />}
              {item}
            </F1FilterItem>
          </Fragment>
        ))}
      </F1Filter>
      <F2Filter>
        {allPossibleF2?.map((item, idx) => (
          <F2FilterItem
            key={item}
            onClick={() => setSelectedF2(item)}
            isSelected={selectedF2 === item}
          >
            {item}
          </F2FilterItem>
        ))}
      </F2Filter>
    </>
  );
};

export default F1AndF2Filters;
